import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { formatCurrency } from '../helpers'
import { NText, MediumText } from 'components/styledComponents/text'
import { useWindowSize } from '../helpers'
import { getCurrentResolutionBreakPoint } from 'utils/utilityFunctions'
import { useSelector } from 'react-redux'

export const CardRowItemHideCurrencyIfNoValue = (props) => {
  let cardClass = `text-right ${props.rightTextcss && props.rightTextcss}`
  const isDownloadingPdf = useSelector(
    (state) => state.downloadPdf && state.downloadPdf.isDownloading
  )
  const [width] = useWindowSize()
  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }

  if (width < resolutionBreakpoint.nonDesktop) {
    cardClass = `font-weight-normal ${props.rightTextcss && props.rightTextcss}`
  }

  return (
    <>
      {/* If there is value > 0, bring two column / row structure */}
      {props.value &&
        props.value > 0 &&
        width >= resolutionBreakpoint.nonDesktop && (
          <>
            <Row>
              <Col className="" xs={7} md={9}>
                {props.normalWeight ? (
                  <NText>{props.title}</NText>
                ) : (
                  props.title
                )}
                {props.subtitle && (
                  <div className="subtitle">{` ${props.subtitle}`}</div>
                )}
                {props.subtitle2 && (
                  <div
                    style={{ fontWeight: 400, fontSize: '16px' }}
                  >{` ${props.subtitle2}`}</div>
                )}
              </Col>
              {props.isCurrency &&
                (props.subtitle2 ? (
                  <Col
                    xs={5}
                    md={3}
                    className={cardClass}
                    style={{ fontWeight: 400, fontSize: '16px' }}
                  >
                    {formatCurrency(props.value)}
                  </Col>
                ) : (
                  <Col xs={5} md={3} className={cardClass}>
                    {formatCurrency(props.value)}
                  </Col>
                ))}
              {!props.isCurrency && (
                <Col xs={5} md={3} className={cardClass}>
                  {props.value}
                </Col>
              )}
            </Row>
          </>
        )}
      {props.value &&
        props.value > 0 &&
        width < resolutionBreakpoint.nonDesktop && (
          <>
            <Row>
              <Col className="" xs={12}>
                {props.normalWeight ? (
                  <NText>{props.title}</NText>
                ) : (
                  props.title
                )}
                {props.subtitle && (
                  <div className="subtitle">{` ${props.subtitle}`}</div>
                )}
                {props.subtitle2 && (
                  <div
                    style={{ fontWeight: 400, fontSize: '14px' }}
                  >{` ${props.subtitle2}`}</div>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              {props.isCurrency &&
                (props.subtitle2 ? (
                  <Col
                    xs={12}
                    // className={cardClass}
                    style={{
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'left',
                    }}
                  >
                    {formatCurrency(props.value)}
                  </Col>
                ) : (
                  <Col xs={12} className={cardClass}>
                    {formatCurrency(props.value)}
                  </Col>
                ))}
              {!props.isCurrency && (
                <Col xs={12} className={cardClass}>
                  {props.value}
                </Col>
              )}
            </Row>
          </>
        )}

      {/* If there is value is NULL or if you want to hide the right column view if no value */}
      {(!props.value || props.value <= 0) && (
        <Row>
          <Col className="" xs={12} md={12}>
            {props.normalWeight ? (
              <NText>{props.title}</NText>
            ) : props.mediumWeight ? (
              <MediumText>{props.title}</MediumText>
            ) : (
              props.title
            )}
            {props.subtitle && (
              <div className="subtitle">{` ${props.subtitle}`}</div>
            )}
            {props.subtitle2 && (
              <div
                style={{ fontWeight: 400, fontSize: '14px' }}
              >{` ${props.subtitle2}`}</div>
            )}
          </Col>
        </Row>
      )}
    </>
  )
}
